export const setToken = ({ accessToken }: { accessToken: string }) =>
  localStorage.setItem('accessToken', accessToken)
export const getToken = () => localStorage.getItem('accessToken')
export const removeToken = () => localStorage.removeItem('accessToken')
